/* rr-reviews.js (5 Oct 2026, v7.2): the reviews the theme draws instead of
   Judge.me's widgets.

   0. Homepage carousel (sections/rr-reviews-home.liquid): the arrows scroll
      the snap track one view at a time and fade at either end.
   The product page reviews section (sections/rr-product-reviews.liquid):

   1. "Read more" on long reviews.
   2. Judge.me on demand. The page shows the reviews the theme drew; Judge.me's
      widget sits in a <template>, so Judge.me's loader (the core app embed,
      which stays on) finds no widget and loads nothing more. When a shopper
      presses Write a review, Ask a question or Show all reviews, the widget
      goes into the page, the loader runs again (its guard reset), and the
      button the shopper wanted is pressed inside Judge.me once it is drawn.
      Judge.me's review request emails (#judgeme, judgeme_token=...) and our
      sign-in return (?rr_review=1) load it on arrival.
   3. Writing reviews. The shop's Judge.me setting "disable_web_reviews" hides
      Judge.me's own Write a review button (since Judge.me's revamped widget,
      jm-* classes, it is not drawn at all). The owner's rule (30 Sept 2026):
      signed-in customers get the button, guests get "Sign in to write a
      review". So for a signed-in customer the setting is lifted in this page
      only, just before Judge.me loads; guests get our sign-in link plus the
      Dino Dollars line in Judge.me's actions column, as rr-review-gate.liquid
      did for the old widget. */
(function () {
  'use strict';
  var doc = document;
  var win = window;

  /* ---- 0. homepage carousel ---------------------------------------------- */
  function reduced() { try { return win.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function initCarousels() {
    [].forEach.call(doc.querySelectorAll('[data-rr-car]'), function (car) {
      if (car.__rrCar) return;
      car.__rrCar = true;
      var track = car.querySelector('[data-rr-car-track]');
      var prev = car.querySelector('[data-rr-car-prev]');
      var next = car.querySelector('[data-rr-car-next]');
      if (!track) return;
      function ends() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 2);
        if (next) next.classList.toggle('is-off', track.scrollLeft >= max);
      }
      function go(dir) {
        track.scrollBy({ left: dir * track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { win.requestAnimationFrame(ends); }, { passive: true });
      win.addEventListener('resize', ends);
      ends();
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initCarousels);
  else initCarousels();

  var root = doc.querySelector('[data-rr-rev]');
  if (!root || root.__rrRev) return;
  root.__rrRev = true;

  var signedIn = root.getAttribute('data-signed-in') === '1';
  doc.documentElement.classList.add(signedIn ? 'rr-cust' : 'rr-guest');
  var native = root.querySelector('[data-rr-rev-native]');
  var app = root.querySelector('[data-rr-rev-app]');
  var tpl = root.querySelector('template[data-rr-rev-tpl]');

  /* ---- 1. Read more ----------------------------------------------------- */
  function initExpand() {
    [].forEach.call(root.querySelectorAll('[data-rr-rev-body]'), function (b) {
      var btn = b.nextElementSibling;
      if (!btn || !btn.hasAttribute('data-rr-rev-expand')) return;
      if (b.scrollHeight - b.clientHeight > 4) btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = b.classList.toggle('is-open');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    });
  }

  /* ---- 2. Judge.me on demand ---------------------------------------------- */
  var mounted = false;
  var WIDGET = '.jm-review-widget, .jdgm-rev-widg';
  var WRITE = '[data-testid="write-review-button"], .jdgm-write-rev-link';
  var ASK = '[data-testid="ask-question-button"], .jdgm-ask-question-btn';
  var ACTIONS = '.jm-action-buttons, .jdgm-widget-actions-wrapper';
  function loaderSrc() {
    var s = doc.querySelector('script[src*="judgeme"][src*="/loader.js"]');
    return s ? s.src : '';
  }
  function whenDrawn(cb) {
    var tries = 0;
    (function look() {
      var w = app.querySelector(WIDGET);
      if (w || ++tries > 50) { cb(w); return; }
      setTimeout(look, 200);
    })();
  }
  function mount(cb) {
    if (mounted) { whenDrawn(cb); return; }
    var src = loaderSrc();
    if (!tpl || !src) { cb(null); return; }
    mounted = true;
    var frag = tpl.content.cloneNode(true);
    /* the section prints the review markup itself; no second copy */
    [].forEach.call(frag.querySelectorAll('script[type="application/ld+json"], script[type="text/x-rr-jld"]'), function (s) { s.remove(); });
    app.appendChild(frag);
    app.hidden = false;
    native.hidden = true;
    if (signedIn && win.jdgmSettings) win.jdgmSettings.disable_web_reviews = false;
    win.jdgm = win.jdgm || {};
    win.jdgm._loaderExecuted = false;
    var s = doc.createElement('script');
    s.src = src;
    s.async = true;
    doc.body.appendChild(s);
    gate();
    whenDrawn(cb);
  }

  function press(sel, check) {
    /* Judge.me redraws the widget a moment after it first appears: press the
       button that is there, and try again until it took (up to about 6 s) */
    var n = 0;
    (function go() {
      if (check && check()) return;
      var b = app.querySelector(sel);
      if (b) b.click();
      if (!check || ++n > 6) return;
      setTimeout(go, 1000);
    })();
  }
  function formOpen() {
    return [].some.call(doc.querySelectorAll('.jdgm-write-review-modal__content, .jdgm-form-wrapper'), function (m) {
      return m.getBoundingClientRect().height > 100;
    });
  }
  function askOpen() {
    return [].some.call(doc.querySelectorAll('.jdgm-ask-question-form, .jdgm-question-form-wrapper, .jdgm-question-form'), function (m) {
      return m.getBoundingClientRect().height > 60;
    });
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  function open(what, btn) {
    busy(btn, true);
    mount(function (w) {
      busy(btn, false);
      if (!w) {
        native.hidden = false;
        app.hidden = true;
        return;
      }
      app.scrollIntoView({ block: 'start' });
      if (what === 'write') setTimeout(function () { press(WRITE, formOpen); }, 600);
      else if (what === 'ask') setTimeout(function () { press(ASK, askOpen); }, 600);
    });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rr-rev-do]');
    if (!b || !root.contains(b)) return;
    e.preventDefault();
    open(b.getAttribute('data-rr-rev-do'), b);
  });

  /* ---- 3. guests: sign in to write a review (from rr-review-gate.liquid) -- */
  var login = root.getAttribute('data-login') || '/account/login';
  function earnLine(col, after) {
    var p = col.querySelector('.rr-rev-dd');
    if (!p) {
      p = doc.createElement('p');
      p.className = 'rr-rev-dd';
      p.setAttribute('data-rr-bonus', 'review');
      p.setAttribute('data-pre', 'Earn ');
      p.setAttribute('data-post', ' for each product review.');
      p.hidden = true;
    }
    if (p.parentNode !== col || p.previousSibling !== after) col.insertBefore(p, after ? after.nextSibling : col.firstChild);
  }
  function place() {
    var w = app.querySelector(WIDGET);
    if (!w) return;
    var l = w.querySelector(WRITE);
    if (!signedIn) {
      var col = w.querySelector(ACTIONS) || (l && l.parentNode);
      if (!col) return;
      var a = col.querySelector('.rr-rev-signin');
      if (!a) {
        a = doc.createElement('a');
        a.className = 'rr-rev-signin';
        a.href = login;
        a.textContent = 'Sign in to write a review';
      }
      if (a.parentNode !== col || col.firstChild !== a) col.insertBefore(a, col.firstChild);
      earnLine(col, a);
      return;
    }
    if (l) earnLine(l.parentNode, l);
  }
  function gate() {
    if (!win.MutationObserver) return;
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; place(); }, 60);
    });
    mo.observe(app, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  /* ---- arrival ----------------------------------------------------------- */
  function arrival() {
    var loc = win.location;
    if (/[?&]rr_review=1\b/.test(loc.search)) {
      try { win.history.replaceState(null, '', loc.pathname + loc.hash); } catch (e) {}
      return signedIn ? 'write' : 'all';
    }
    if (loc.hash === '#judgeme' || loc.hash === '#judgeme_product_reviews') return 'all';
    if (/[?&]judgeme_[a-z_]+=/.test(loc.search)) return 'all';
    return '';
  }

  function boot() {
    initExpand();
    var a = arrival();
    if (a) open(a, null);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
